import axios from "../../shared/axios.utils";
import { DASH_API } from "../../shared/url.consts";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoanDocuments } from "../../types/loan-documents";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";

export const returnLoanDocuments = async (loanId: string) => {
  return axios.get<LoanDocuments>(`${DASH_API}/loans/${loanId}/documents`);
};

export const returnLoanDocumentsResponse = async (loanId: string) => {
  try {
    const response = await returnLoanDocuments(loanId);
    if (response.status === 200) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `non 200 response received: ${response}`,
        AppInsightsErrorType.GET_LOAN_DOCUMENTS
      );
      return response.data;
    }
  } catch (err: any) {
    sendAppInsightsServerError(
      `error fetching loan application: ${err}`,
      AppInsightsErrorType.GET_LOAN_DOCUMENTS
    );
  }
};

export const fetchLoanDocuments = createAsyncThunk(
  "loan-documents/get",
  returnLoanDocumentsResponse
);
